import React, { useEffect, useState } from "react";
import alumniApi from "../../config/alumniApi";
import styles from "./AlumniPages.module.css";

const EMPLOYMENT_OPTIONS = [
  { value: "EMPLOYED", label: "Employed" },
  { value: "SELF_EMPLOYED", label: "Self-Employed" },
  { value: "STUDENT", label: "Studying" },
  { value: "UNEMPLOYED", label: "Unemployed" },
];

const EDITABLE_FIELDS = [
  "company_name",
  "designation",
  "employment_status",
  "higher_education",
  "city",
  "state",
  "country",
  "linkedin_url",
  "facebook_url",
  "instagram_url",
  "email",
];

const AlumniProfile = () => {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const loadProfile = () => {
    setLoading(true);
    alumniApi
      .get("/alumni/profile")
      .then(({ data }) => {
        setProfile(data);
        const initial = {};
        EDITABLE_FIELDS.forEach((key) => {
          initial[key] = data[key] || "";
        });
        setForm(initial);
      })
      .catch(() => setError("Failed to load profile."))
      .finally(() => setLoading(false));
  };

  useEffect(loadProfile, []);

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");
    setError("");
    try {
      await alumniApi.put("/alumni/profile", form);
      setMessage("Profile updated successfully.");
      loadProfile();
    } catch (err) {
      setError(err.response?.data?.error || "Failed to update profile.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className={styles.emptyState}>Loading profile...</div>;

  return (
    <div>
      <h1 className={styles.heading}>My Profile</h1>
      <p className={styles.subheading}>
        {profile?.student_name} · {profile?.batch_name || "Batch not set"} ·{" "}
        {profile?.cohort_name || "Cohort not set"}
      </p>

      {message && <div className={styles.card} style={{ color: "#027a48" }}>{message}</div>}
      {error && <div className={styles.card} style={{ color: "#b42318" }}>{error}</div>}

      <form className={styles.panel} onSubmit={handleSubmit}>
        <div className={styles.formGrid}>
          <div className={styles.field}>
            <label className={styles.label}>Company Name</label>
            <input className={styles.input} value={form.company_name} onChange={update("company_name")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Designation</label>
            <input className={styles.input} value={form.designation} onChange={update("designation")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Employment Status</label>
            <select className={styles.select} value={form.employment_status} onChange={update("employment_status")}>
              <option value="">Select status</option>
              {EMPLOYMENT_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Higher Education</label>
            <input className={styles.input} value={form.higher_education} onChange={update("higher_education")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>City</label>
            <input className={styles.input} value={form.city} onChange={update("city")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>State</label>
            <input className={styles.input} value={form.state} onChange={update("state")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Country</label>
            <input className={styles.input} value={form.country} onChange={update("country")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Email</label>
            <input className={styles.input} type="email" value={form.email} onChange={update("email")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>LinkedIn URL</label>
            <input className={styles.input} value={form.linkedin_url} onChange={update("linkedin_url")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Facebook URL</label>
            <input className={styles.input} value={form.facebook_url} onChange={update("facebook_url")} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Instagram URL</label>
            <input className={styles.input} value={form.instagram_url} onChange={update("instagram_url")} />
          </div>
        </div>

        <button type="submit" className={styles.button} disabled={saving}>
          {saving ? "Saving..." : "Save Profile"}
        </button>
      </form>
    </div>
  );
};

export default AlumniProfile;
